import { render, staticRenderFns } from "./HailingInfo.vue?vue&type=template&id=6786361a&scoped=true&lang=pug"
import script from "./HailingInfo.vue?vue&type=script&lang=js"
export * from "./HailingInfo.vue?vue&type=script&lang=js"
import style0 from "./HailingInfo.vue?vue&type=style&index=0&id=6786361a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6786361a",
  null
  
)

export default component.exports